// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */
import {connect} from "react-redux";
import type {StoreState} from "../../../reducers/combinedReducers";
import {extractCaller} from "../../QueryPage";
import type {GenericModalDispatchProps, GenericModalStateProps} from "../../../components/GenericModal";
import GenericModal from "../../../components/GenericModal";
import type {Caller} from "../../../components/QueryPage";
import {closeEBadgeButtonModalAction, eBadgeButtonAction} from "../../../actions/ebadge/creators/eBadgeButtonActionCreator";
import {changePhotoVerificationStatus} from "../../../dao/eBadgeDao";

function getIsLoadingStatus(state, registrationCode) {
    let status = state.eBadgeAction['validatePhoto'] && state.eBadgeAction['validatePhoto'][registrationCode];
    if (status) {
        return status.isLoading;
    } else {
        return false;
    }
}

type Args = {
    registrationCode: string,
    caller: Caller
}

const mapStateToProps = (state: StoreState): GenericModalStateProps => {

    const registrationCode = state.modal['validatePhoto'] && state.modal['validatePhoto'].identifier;
    const isLoading = registrationCode ? getIsLoadingStatus(state, registrationCode)
        : false;

    const args: Args = {
        registrationCode: registrationCode || '',
        caller: extractCaller(state)
    };
    return {
        open: state.modal['validatePhoto'] && state.modal['validatePhoto'].open,
        promptMsg: `Are you sure to validate ${registrationCode || 'Photo'}? `,
        loadingMsg: `OK. We are validating ${registrationCode || 'Photo'}`,
        isLoading,
        error: state.eBadgeAction['validatePhoto'] && state.eBadgeAction['validatePhoto'].error,
        primaryActionText: 'Validate Photo',
        primaryActionColor: "success",
        primaryActionClassName: "light-green",
        args: args
    }
};

const mapDispatchToProps = (dispatch): GenericModalDispatchProps => {
    return {
        primaryAction: (args: Args) => {
            dispatch(eBadgeButtonAction(args.registrationCode, args.caller, "validatePhoto",
                async (registrationCode, caller, authToken) => {
                    return await changePhotoVerificationStatus(registrationCode, caller, authToken, "Y")
                }));
        },
        closeModal: () => {
            dispatch(closeEBadgeButtonModalAction("validatePhoto"));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(GenericModal);



// WEBPACK FOOTER //
// ./src/containers/ebadge/photo/ValidateEBadgePhotoModal.js